enum UbiIDStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  NEEDS_MANUAL_REVIEW = 'NEEDS_MANUAL_REVIEW',
  MANUALLY_CONFIRMED = 'MANUALLY_CONFIRMED',
  MANUALLY_DECLINED = 'MANUALLY_DECLINED',
}

export default UbiIDStatus
